import { client as request } from "./request";
import { ResponseEntries } from "./report-api";
import { FolderEntry } from "@/models/file";

export async function getPhotoEntries(
  projectId: any,
  currentFolderId: any,
  serviceId = null
) {
  const res = await request.get("get_photo_entries.php", {
    projectId,
    currentFolderId,
    serviceId
  });
  return {
    ...res,
    entries: (res.entries || []).map(FolderEntry.create)
  } as ResponseEntries;
}

export async function getTemplateEstimateEntries(
  currentFolderId: any,
  serviceId = null,
  isEstimate = true
) {
  const res = await request.get("get_photo_entries.php", {
    currentFolderId,
    serviceId,
    isEstimate
  });
  return {
    ...res,
    entries: (res.entries || []).map(FolderEntry.create)
  } as ResponseEntries;
}

/**
 * 写真を保存する
 */
export async function savePhotoEntry(data: FormData) {
  await request.post("save_photo_entry.php", data).catch(e => {
    alert(e);
  });
}

/**
 * 写真を削除する
 */
export async function deletePhotoEntry(id: any) {
  const data = new FormData();
  data.append("id", id);
  await request.post("delete_photo_entry.php", data);
}

export async function readPhotoEntry(entryId: any) {
  const data = new FormData();
  data.append("entryId", entryId);
  await request.post("read_photo_entry.php", data);
}
